import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'

export const expensesByCategoryItemSchema = z.object({
  // either a real category uuid or the literal `'uncategorized'` sentinel
  // used for shared-expense leftovers where the viewer cannot see the per-split category.
  id: z.string(),
  name: z.string(),
  color: z.string().nullable(),
  icon: z.string().nullable(),
  values: z.array(z.number()),
  total: z.number(),
  monthlyAverage: z.number(),
})

export type ExpensesByCategoryItemDto = z.infer<typeof expensesByCategoryItemSchema>

export const expensesByCategoryResponseSchema = z.object({
  baseCurrency: z.nativeEnum(Currency),
  range: z.object({
    from: z.string(),
    to: z.string(),
  }),
  months: z.array(z.string()),
  categories: z.array(expensesByCategoryItemSchema),
  monthlyTotals: z.array(z.number()),
  rangeMonthlyAverage: z.number(),
  skippedExpenseCount: z.number().int().nonnegative(),
})

export type ExpensesByCategoryResponseDto = z.infer<typeof expensesByCategoryResponseSchema>
